import { render, staticRenderFns } from "./LoginUsernamePassword.vue?vue&type=template&id=cb63e30c&scoped=true"
import script from "./LoginUsernamePassword.vue?vue&type=script&lang=ts"
export * from "./LoginUsernamePassword.vue?vue&type=script&lang=ts"
import style0 from "./LoginUsernamePassword.vue?vue&type=style&index=0&id=cb63e30c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb63e30c",
  null
  
)

export default component.exports